module.exports = __webpack_public_path__ + "assets/img/copper-bei.9b7eb390.png";